import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BasicLambdaFields from 'components/Providers/BasicLambdaFields';
import { Form } from '../../../modules/react-forms/lib';
import Button from '../../../modules/ui-kit-react/lib/components/Button';
import style from '../style.module.css';

class BasicLambdaForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    configuration: PropTypes.shape({
      id: PropTypes.string
    }),
    gqlError: PropTypes.shape({
      graphQLErrors: PropTypes.array
    })
  };

  static defaultProps = {
    gqlError: null,
    configuration: null
  };

  form = React.createRef();

  render() {
    const { configuration, onCancel, onSubmit, gqlError } = this.props;

    return (
      <React.Fragment>
        <div className={style.content}>
          <Form ref={this.form} onSubmit={onSubmit}>
            <BasicLambdaFields
              configuration={configuration}
              gqlError={gqlError}
            />
          </Form>
        </div>
        <div className={style.foot}>
          <Button
            raised
            appearance="primary"
            onClick={() => this.form.current.submit()}
          >
            Update
          </Button>
          <Button appearance="danger" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

export default BasicLambdaForm;
